"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderById = void 0;
const getOrderById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("orders")
        .select(`*,        
        reminders(*),
        client:user_profiles!client_id(*),
        quotes:quotes!order_id(*),
        agent:agent_accounts!agent_id(*, agent_config:agent_configurations!agent_config_id(*)),
        variants:order_variants!order_id(*,
          order_lines!id(*,         
            reminders(*),
            order_notes(*),
            versions:order_line_versions!order_line_id(
              *,
              regions(id, name, slug, country_id, weekend_days),
              order_lines!linked_line_id(*, 
                versions:order_line_versions!order_line_id
                (*)
              )
            )
          )
        ),
        order_lines!id
        (
            *,                        
            reminders(*), 
            order_notes(*),
            versions:order_line_versions!order_line_id(
                *,
                regions(id, name, slug, country_id, weekend_days),
                order_lines!linked_line_id(*, 
                versions:order_line_versions!order_line_id
                (*)
            )
        )
        ),  
        transactions(*, transaction_items(*)),
        payment_requests:payment_requests!order_id(*),
        created_by_user:created_by(id, first_name, last_name),
        assigned_to_user:assigned_to(id, first_name, last_name)
        `)
        .eq("id", id)
        .single();
    if (error) {
        throw new Error(error.message);
    }
    return data;
};
exports.getOrderById = getOrderById;
